/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $InputText, ExtendContainerProps, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {inputNumberValidate} from '@gongxigames/framework/core/utils/inputNumberValidate';
import {COLOR_POPUP_BG3} from '@gongxigames/framework/slotV2/ui/ui-ruby/CONSTANTS';

export type $AutoplayInputProps = ExtendContainerProps<{
    onChange: (value: number | null) => void;
    onUpdate: (value: number | null) => void;
    value: number | null;
}>;

export const $AutoplayInput: FC<$AutoplayInputProps> = (props) => {
    const currencyFormatter = slotStore.currencyFormatter.value!;
    const active = Store.signal(false);
    const inputValue = Store.signal(String(props.value));
    const inputText = Store.computed(() =>
        !inputValue.value ? '' : active.value ? String(inputValue.value) : currencyFormatter.format(Number(inputValue.value))
    );
    const isValidInput = Store.computed(
        () => inputValue.value !== '' && inputNumberValidate(inputValue.value) && Number(inputValue.value) > 0
    );

    const computedInputEffect = Store.effect(() => {
        const value = getProp(props.value);

        if (!value) {
            inputValue.value = '';
        } else {
            inputValue.value = String(value);
        }
    });

    const onChangeInput = (value: string): void => {
        const prevValue = inputValue.value;

        inputValue.value = value;

        if (!inputNumberValidate(value)) {
            inputValue.value = prevValue;
        } else {
            getProp(props.onUpdate)(Number(inputValue.value));
        }
    };

    const onFocusInput = (): void => {
        active.value = true;
    };

    const onBlurInput = (): void => {
        if (isValidInput.value) {
            getProp(props.onChange)(Number(inputValue.value));
        } else {
            if (!getProp(props.value)) {
                inputValue.value = '';
            } else {
                getProp(props.onChange)(null);
            }
        }

        active.value = false;
    };

    return (
        <$InputText
            {...props}
            events={{ destroyed: [computedInputEffect] }}
            text={inputText}
            textStyle={{
                maxLength: 8,
                width: `${120 * 3}px`,
                fontFamily: 'PF DinDisplay Pro',
                fontSize: '42px',
                padding: '18px 30px',
                color: 'white',
                textAlign: 'right',
                fontWeight: 'lighter',
            }}
            boxStyle={{
                default: {
                    fill: COLOR_POPUP_BG3,
                    rounded: 40,
                },
            }}
            disabledPasteFromClipboard={true}
            inputEvents={{
                input: onChangeInput,
                focus: onFocusInput,
                blur: onBlurInput,
            }}
        />
    );
};
